
/**
 * Created by rathompson on 1/12/23
 * File: ScopeRenderer
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

import { Body } from '@panwds/react-ui'
import { OBJECT } from '../../../../../common/utils/Utils'

const ScopeRenderer = ({ row }) => (
  <div className='tw-flex tw-flex-col tw-gap-0.5 tw-h-full tw-w-full tw-p-1'>
    {OBJECT.hasObject(row?.original?.roles) && Object.entries(row?.original?.roles).sort().map(([app_id, policies]) => {
      return policies?.map(({ resource }, index) => (
        <div key={index} className='tw-flex-1 tw-flex'>
          <Body size="lg" addClassName='tw-truncate'>{resource?.resource_scope || ''}</Body>
        </div>
      ))
    })}
  </div>
)

ScopeRenderer.propTypes = {}
export default ScopeRenderer

